import './placeholder.css'
import Overlay from '../overlay/Overlay';
import ContentGrid from '../ContentGrid';
import Spacer from '../Spacer';
import PlaceHolderService, { IPlaceHolderService } from './PlaceHolderService';

interface PulseCardPlaceholderProps {
    title?: string,
    titleIcon?: string,
    size?: string
}
export const PulseCardPlaceholder = ({ title, titleIcon, size = "large" }: PulseCardPlaceholderProps) => {

    return (
        <>
            <ContentGrid
                title={title}
                titleIcon={titleIcon}
                showOfflineWarning={false}>
                <Spacer height={20} />
                <CardPlaceholderContent size={size} />
            </ContentGrid>
            <Overlay isBusy = { true} />
        </>
    )
}

interface CardPlaceholderContentProps {
    size: string
}
const CardPlaceholderContent = ({ size }: CardPlaceholderContentProps) => {

    const service: IPlaceHolderService = new PlaceHolderService();

    return (
        <div
            className="pulse"
            style={{ height: service.getHeight(size) }}
        />
    )
}

